
export const WIDTH_PMODE1 = 128;
export const HEIGHT_PMODE1 = 96;
export const WIDTH_PMODE4 = 256;
export const HEIGHT_PMODE4 = 192;

export const ZOOM_PMODE1 = 10;
export const ZOOM_PMODE4 = 5;

export const PALETTES_PMODE1 = [
  ['#00FF00', '#FF0000', '#FFFF00', '#0000FF'], // Set 1: Green, Red, Yellow, Blue
  ['#F5F5F5', '#00FFFF', '#FF00FF', '#FFA500']  // Set 2: Buff, Cyan, Magenta, Orange
];

export const PALETTES_PMODE4 = [
  ['#000000', '#00FF00'], // Set 1: Black, Green
  ['#000000', '#F5F5F5']  // Set 2: Black, Buff
];

export const PALETTE_NAMES_SET_PMODE1 = [
  ['GREEN', 'RED', 'YELLOW', 'BLUE'],
  ['BUFF', 'CYAN', 'MAGENTA', 'ORANGE']
];

export const PALETTE_NAMES_SET_PMODE4 = [
  ['BLACK', 'GREEN'],
  ['BLACK', 'BUFF']
];
